import type { PublicApiKey } from '#packages/apilib';
import type { createComponentsApi } from './componentsWrapper';

export const ComponentsApiKey: PublicApiKey<typeof createComponentsApi> = {
  name: 'ComponentsApi',
  public: true,
};
